var React = require('react');

function IconExit (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"nonzero"},[React.createElement("path",{"d":"M2 8a1 1 0 1 1-2 0V4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4v-4a1 1 0 0 1 2 0v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v4z","key":0}),React.createElement("path",{"d":"M15.612 11l-4.317-4.29a1 1 0 1 1 1.41-1.42l6.555 6.516-6.553 6.553a1 1 0 0 1-1.414-1.414L15.238 13H1a1 1 0 0 1 0-2h14.612z","key":1})]));
}

IconExit.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = IconExit;

IconExit.default = IconExit;
